
import Css from './Css.js'

//视频播放刻度组件(与视频播放同步的小蓝色滑块)
function Progress(props){
  const {middleWidth,videoEl,videoTotalTime,selStartTime,selEndTime} = props.data;
  // const videoInfo = dataInfo.videoInfo;
  // const videoEl = dataInfo.videoEl;
  // let middleWidth = dataInfo.middleWidth;
  const minLeft = 3;
  let marginLeft = minLeft;  
  let progressWidth = middleWidth - 2*minLeft;
  let videoPregress = parseInt(videoEl.currentTime*1000);
  // 视频播放中，需计算组件移动效果
  marginLeft = Math.ceil((videoPregress/videoTotalTime)*progressWidth) + minLeft;
  // if(progressLeft){
  //   marginLeft = progressLeft + minLeft;
  // }
  let sliderW = Math.ceil(((selEndTime - selStartTime)/videoTotalTime)*middleWidth);
  if(marginLeft >= (sliderW - 6)){
    let cha = marginLeft - (sliderW-6);
    if(cha>0 && cha<6){
      marginLeft = marginLeft - cha;
    }else if(cha >= 6){
      marginLeft = marginLeft - 6;
    }
  }
  if(marginLeft >= progressWidth){
    marginLeft = progressWidth + minLeft;
  }
  if(marginLeft <= minLeft){
    marginLeft = minLeft;
  }
  return (
    <div style={ Css.getStyle(marginLeft) }></div>
  )
}
export default Progress;